import { Col, Row } from "react-bootstrap";
import ReactCountryFlag from "react-country-flag";

interface IProps {
  countryCode: string;
  countryName?: string;
  isDropDown?: boolean;
}

const CountryFlag = (props: IProps) => {
  const { countryCode, countryName, isDropDown = true } = props;

  return (
    <Row className="row-cols-auto align-items-center">
      <Col className="pe-0">
        <ReactCountryFlag
          countryCode={countryCode}
          svg
          style={{
            width: "15px",
            height: "15px",
          }}
          title={countryName}
          className="d-flex align-items-center"
        />
      </Col>
      {isDropDown ? (
        <Col>{countryName}</Col>
      ) : (
        <Col className="title-2 font-weight-600 font-size-12 ps-2">
          {countryCode}
        </Col>
      )}
    </Row>
  );
};

export default CountryFlag;
